// extracted by mini-css-extract-plugin
export default {"header":"Tabs_header__kFcKS","headerItem":"Tabs_headerItem__21Irc","headerItemActive":"Tabs_headerItemActive__zQbQ-"};